<template>
  <div class="recover">
    <h1 class="title">{{pageHeader}}</h1>
    <form class="recover-form" @submit.prevent="recover">
      <TextInput class="text-input"
                 label="Your email"
                 placeholder="astro.naut@timenaut.app"
                 v-model:value="email"
                 :error="emailError"
      />
      <Button class="button" type="submit">
        <template v-slot:icon-right>
          <ArrowRight/>
        </template>
        Send recovery link
      </Button>
    </form>

    <router-link to="/login">
      <TextButton class="text-button" dark>I already have an account</TextButton>
    </router-link>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Button, Checkbox, TextButton, TextInput} from "@timenaut/timenaut-vue-common"
import axios, {AxiosError} from 'axios';
import ArrowRight from "@timenaut/timenaut-vue-common/lib/assets/icons/feather/arrow-right.svg"

@Options({
  components: {
    TextInput,
    Button,
    TextButton,
    Checkbox,
    ArrowRight,
  },
})
export default class extends Vue {
  email: string = "";

  pageHeader: string = "Recover your account";

  emailError: string = "";

  emailRegex = RegExp(/.*@.*\..*/);

  async recover() {
    this.emailError = "";

    if (!this.email.match(this.emailRegex)) {
      this.emailError = "Not a valid email";
      return;
    }

    axios.post(process.env.VUE_APP_API_URL + "/auth/recover", {
      email: this.email,
    })
        .then(() => {
          this.pageHeader = `Instructions for recovery have been sent to ${this.email}`;
        })
        .catch(() => {
          this.emailError = "Unexpected error occurred"
        })
  }
}
</script>
<style scoped>
.recover {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: #16056B;
}

.recover-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
}

.text-input {
  margin: 12px 0;
  width: 320px;
}

.text-button {
  margin: 16px;
}

a {
  color: #16056B;
  text-decoration: underline;
}

.button {
  align-self: center;
  width: 280px;
}
</style>
